export interface SplitName {
  firstName: string
  lastName: string
}

export function splitFullName(name?: string): SplitName {
  const trimmed = (name ?? '').trim().replace(/\s+/g, ' ')
  if (!trimmed) {
    return { firstName: '', lastName: '' }
  }
  const idx = trimmed.indexOf(' ')
  if (idx === -1) {
    return { firstName: trimmed, lastName: '' }
  }
  return { firstName: trimmed.slice(0, idx), lastName: trimmed.slice(idx + 1) }
}

/**
 * Resolve first/last name from an optional explicit pair, falling back per field to splitting the
 * full name. An empty string counts as an explicit value (so a cleared field is respected); only
 * null/undefined trigger the split fallback.
 */
export function resolveNameParts(firstName: string | null | undefined, lastName: string | null | undefined, fullName?: string | null): SplitName {
  const fallback = splitFullName(fullName ?? undefined)
  return {
    firstName: firstName ?? fallback.firstName,
    lastName: lastName ?? fallback.lastName,
  }
}

export function joinFullName(firstName?: string, lastName?: string): string {
  return `${(firstName ?? '').trim()} ${(lastName ?? '').trim()}`.trim()
}
